import React, { useEffect, useState } from "react";
import AppRoutes from "./routes";
import { Provider } from "react-redux";
import { store } from "./store";
import "antd/dist/antd.css";
import "./styles/_main.scss";
import AuthService from "./services/AuthService/auth.service";
import { ROOT } from "./routes/routeConstants/appRoutes";

const App = () => {
  const { getUserDetails } = AuthService();
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(
    () => (getUserDetails(true, () => setIsLoggedOut(true)), void 0),
    []
  );

  return (
    <Provider store={store}>
      <div className="App">
        <AppRoutes redirectUrl={isLoggedOut ? ROOT : undefined} />
      </div>
    </Provider>
  );
};

export default App;
